import { Component, OnInit, Input } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { LocalStorageService } from 'ngx-webstorage';
import { ExcessProtect } from 'src/app/model/quote/excessprotect/excessprotect.model';
import { ExcessProtectService } from '../../excess.service';

@Component({
  selector: 'app-excess-protect-full-details',
  templateUrl: './excess-protect-full-details.component.html',
  styleUrls: ['./excess-protect-full-details.component.css']
})
export class ExcessProtectFullDetailsComponent implements OnInit {

  quote;
  quoteApplicationData = new ExcessProtect();
  CoverTo;
  coverLimitOptions = [];
  @Input() set quoteDetails(value: any) {
    if (value) {
      this.quote = value;
    }
  }
  constructor(private sessionSt: LocalStorageService, private excessProtectService: ExcessProtectService) { }
  ngOnInit(): void {
    this.getExcessProtectOptionsList();
  }
  public getExcessProtectOptionsList() {
    // GET UNIQUE ID FOR DRIVERS
    this.excessProtectService.getExcessProtectOptions()
      .subscribe(
        (response: any) => {
          if (response) {
            this.coverLimitOptions = response;
            this.coverLimitOptions = response.result.map(option => ({
              ...option,

            }));
          }
        },
        (error) => { }
      );
  }
  getCoverLimitName(optionId: number): string {
    const option = this.coverLimitOptions?.find(opt => opt.id === optionId);

    if (!option?.name) {
      return '';
    }

    const match = option.name.match(/£([0-9,]+)/);

    return match ? match[1].replace(/,/g, '') : '';
  }
}
